import { render, staticRenderFns } from "./banners.vue?vue&type=template&id=5051da4f&scoped=true&"
import script from "./banners.vue?vue&type=script&lang=js&"
export * from "./banners.vue?vue&type=script&lang=js&"
import style0 from "./banners.vue?vue&type=style&index=0&id=5051da4f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5051da4f",
  null
  
)

export default component.exports